import EventEmitter from "eventemitter3";

let eventEmitter = new EventEmitter();

// @ts-ignore
window.eventBus = eventEmitter;

export default eventEmitter;
